import React from "react";

export default function FeaturedEmployeRender(props) {
  return (
    

      <div className='col-12'>
      <div className='row'>
      <div className="col-12 col-md-5 mt-3 mb-4">
        <img
          src={props.item.img}
          alt="employee"
          className="img-fluid featured-photo card-img mt-2"
        />
      </div>
      <div className="col-12 col-md-7 mt-3">
        <div className="card-body">
          <div className="card-title">
            <h5>
              {props.item.fname} {props.item.lname}
            </h5>
          </div>
          <div>
            <p>
              {props.item.fname} about{" "}
              {props.item.sex === "male" ? "himself" : "herself"}:
            </p>
            <p className="text-justify">{props.item.description}</p>
          </div>
          <div className='text-right'>Email:{' '}{props.item.eMail}</div>
        </div>
      </div>
      </div>

      </div>
   
  );
}
